import React, { useState, useEffect } from "react";
import { ANNEES_ANCRAGE } from "../constants.js";

// Convertit un objet {annee: nombre} en objet {annee: "texte"} pour l'édition
function toStringMap(obj, defaultVal) {
  return Object.fromEntries(
    ANNEES_ANCRAGE.map((a) => [a, String(obj?.[a] ?? defaultVal)])
  );
}

// Convertit un objet {annee: "texte"} en objet {annee: nombre} pour l'API
function toNumberMap(obj, defaultVal) {
  return Object.fromEntries(
    ANNEES_ANCRAGE.map((a) => {
      const n = Number(String(obj?.[a] ?? defaultVal).replace(",", "."));
      return [a, Number.isFinite(n) ? n : defaultVal];
    })
  );
}

export default function ParametresMargeModal({
  isOpen,
  onClose,
  chargesFixes,
  setChargesFixes,
  lissage,
  setLissage,
  prixEau,
  setPrixEau,
  prixElec = {},
  setPrixElec,
}) {
  // brouillon local : les modifications ne s'appliquent qu'au clic sur
  // "Enregistrer" — fermer la popup (croix, clic en dehors) n'affecte rien.
  // Les prix restent en TEXTE pendant l'édition (pas en nombre), sinon taper
  // "0." se fait effacer avant même de pouvoir taper le chiffre suivant.
  const [draft, setDraft] = useState({
    chargesFixes,
    lissage,
    prixEau: toStringMap(prixEau, 0.1),
    prixElec: toStringMap(prixElec, 0.19),
  });

  // resynchronise le brouillon avec les vraies valeurs à chaque ouverture
  useEffect(() => {
    if (isOpen) {
      setDraft({
        chargesFixes,
        lissage,
        prixEau: toStringMap(prixEau, 0.1),
        prixElec: toStringMap(prixElec, 0.19),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    setChargesFixes(draft.chargesFixes);
    setLissage(draft.lissage);
    setPrixEau(toNumberMap(draft.prixEau, 0.1));
    setPrixElec(toNumberMap(draft.prixElec, 0.19));
    onClose();
  };

  return (
    <div className="diagoeau-modal-overlay" onClick={onClose}>
      <div className="diagoeau-modal" onClick={(e) => e.stopPropagation()}>
        <div className="diagoeau-modal-header">
          <h3>Affiner les paramètres</h3>
          <button className="diagoeau-modal-close" onClick={onClose} aria-label="Fermer">
            ×
          </button>
        </div>

        <div className="diagoeau-modal-body">
          <div className="diagoeau-field">
            <label>Charges fixes (€)</label>
            <input
              type="number"
              value={draft.chargesFixes}
              onChange={(e) => setDraft({ ...draft, chargesFixes: Number(e.target.value) })}
            />
          </div>

          <div className="diagoeau-field">
            <label>Fenêtre de lissage (ans)</label>
            <input
              type="number"
              min={1}
              max={11}
              step={2}
              value={draft.lissage}
              onChange={(e) => setDraft({ ...draft, lissage: Number(e.target.value) })}
            />
          </div>

          <div className="diagoeau-field">
            <label>Coût de l'eau (€/m³) par période</label>
            <table className="diagoeau-data-table diagoeau-prix-eau-table">
              <thead>
                <tr>
                  <th>À partir de</th>
                  {ANNEES_ANCRAGE.map((a) => (
                    <th key={a}>{a}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Coût (€/m³)</td>
                  {ANNEES_ANCRAGE.map((a) => (
                    <td key={a}>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={draft.prixEau[a] ?? ""}
                        onChange={(e) =>
                          setDraft({ ...draft, prixEau: { ...draft.prixEau, [a]: e.target.value } })
                        }
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          <div className="diagoeau-field">
            <label>Coût de l'électricité (€/kWh) par période</label>
            <table className="diagoeau-data-table diagoeau-prix-eau-table">
              <thead>
                <tr>
                  <th>À partir de</th>
                  {ANNEES_ANCRAGE.map((a) => (
                    <th key={a}>{a}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Coût (€/kWh)</td>
                  {ANNEES_ANCRAGE.map((a) => (
                    <td key={a}>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={draft.prixElec[a] ?? ""}
                        onChange={(e) =>
                          setDraft({ ...draft, prixElec: { ...draft.prixElec, [a]: e.target.value } })
                        }
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="diagoeau-modal-footer">
          <button className="diagoeau-btn" onClick={handleSave}>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}